import { getYesOrNo } from "utils/utils.js";
import { ALARMS_TABLE_STRINGS } from "constants/constantStrings";

import TagDeleteRenderer from "pages/TagList/TagDeleteRenderer.js";

import TagEditRenderer from "../../TagList/TagEditRenderer.jsx";

import AlarmsListCheckboxRenderer from "./AlarmsListCheckboxRenderer";
import AlarmsListHeaderCheckboxRenderer from "./AlarmsListHeaderCheckboxRenderer";

const getHeaderWithCheckboxCol = field => ({
  field,
  editable: false,
  sortable: false,
  headerComponentFramework: AlarmsListHeaderCheckboxRenderer,
  headerComponentParams: { field },
  cellRendererFramework: AlarmsListCheckboxRenderer,
  valueFormatter: params => getYesOrNo(params.data[field]),
  cellRendererParams: { field }
});

const ALAMRS_LIST_TABEL_COL_DEF = [
  {
    field: "AlarmID",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmID,
    flex: 1,
    editable: false
  },
  {
    field: "AlarmName",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmName,
    flex: 1,
    editable: false
  },
  {
    field: "Description",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmDesc,
    flex: 1,
    editable: false
  },
  {
    field: "SendAlert",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmAlert,
    ...getHeaderWithCheckboxCol("SendAlert")
  },
  {
    field: "ShowInReport",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmAddToReport,
    ...getHeaderWithCheckboxCol("ShowInReport")
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: TagEditRenderer
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: TagDeleteRenderer,
    cellStyle: params => {
      if (params.data && !params.data.IsDeletable) {
        return {
          backgroundColor: "var(--color-light-grey)",
          color: "var(--color-medium-grey)"
        };
      }
    }
  }
];

export const getAlarmsListTableColDef = (filter, headerProps, admin) =>
  ALAMRS_LIST_TABEL_COL_DEF.map((colDef, idx) => {
    if (idx < 3 || idx === 5 || idx === 6) {
      colDef = { ...colDef, filter };
    } else {
      const { headerComponentParams } = colDef;
      headerComponentParams.headerProps = headerProps;
      colDef = { ...colDef, headerComponentParams };
    }
    if (idx === 5 || idx === 6) {
      colDef = { ...colDef, hide: !admin, suppressToolPanel: !admin };
    }
    return colDef;
  });
